import { featureAtom } from "@sunrise/feature-flags";

export const allowNumericZappingFlagAtom = featureAtom(
  "allow-numeric-zapping",
  false,
  {
    description: "Allow zapping through the number keys on the remote.",
  },
);
